import type { ExpressionSpecification } from "maplibre-gl";
import { POOL_CONDITION_COLORS, type PoolCondition } from "@/lib/reveal";

/**
 * MapLibre match expression coloring a feature's "condition" property with
 * the standard pool condition palette (ts/lib/reveal.ts). Use as the
 * paint color of fill/line layers over pool feature collections.
 */
export function conditionMatchExpression(): ExpressionSpecification {
	const expr: unknown[] = ["match", ["get", "condition"]];
	for (const [cond, color] of Object.entries(POOL_CONDITION_COLORS)) {
		expr.push(cond, color);
	}
	expr.push("#6c757d"); // fallback
	// The constructed array is a valid MapLibre match expression; TS cannot
	// infer the union type from the dynamically-built entries.
	return expr as unknown as ExpressionSpecification;
}

/** Hex color for a pool condition (POOL_CONDITION_COLORS, grey fallback). */
export function conditionColorHex(condition: string): string {
	return POOL_CONDITION_COLORS[condition as PoolCondition] ?? "#6c757d";
}
